'use client';

import type { FC, ReactNode } from 'react';
import { useEffect } from 'react';
import { Alert as AlertEQI, useToast } from '@eqi-investimentos/react';
import { type ToastPosition, useDisclosure } from '@chakra-ui/react';
import { WalletAlerts } from '@/modules/Wallet/interface/alerts';

export const Alert: FC<AlertProps> = ({
  displayIcon = false,
  type = 'stripe',
  position,
  isClosable,
  ...options
}) => {
  const toast = useToast();
  const { isOpen, onOpen } = useDisclosure();

  useEffect(() => {
    if (type !== 'popup') return onOpen();

    const toastOptions = {
      ...options,
      position,
      isClosable,
    };

    toast(toastOptions);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (!isOpen) return <></>;

  return (
    <AlertEQI
      showIcon={displayIcon}
      title={options.title}
      description={options.description}
      variant={options.variant}
      {...options}
    />
  );
};

type AlertProps = {
  title?: ReactNode;
  description?: ReactNode;
  variant?: 'neutral' | 'info' | 'success' | 'error' | 'warning';
  displayIcon?: boolean;
  position?: ToastPosition;
  isClosable?: boolean;
  type?: WalletAlerts['type'];
};
